import type {
  SaleCheckout,
  WalkInSaleCreate,
} from "@/types/sales/api-types/sale-types";
import type { SaleCheckoutParsedValues } from "@/zod-schemas/sales/sale-checkout-schema";
import type { WalkInSaleParsedValues } from "@/zod-schemas/sales/walk-in-sale-schema";

/** AppointmentServiceConfig still requires HH:MM; create_walk_in_sale overwrites with salon_now_hhmm(). */
const WALK_IN_START_TIME_PLACEHOLDER = "00:00";

export const toSaleCheckout = (
  values: SaleCheckoutParsedValues
): SaleCheckout => ({
  discount_percent: values.discount_percent,
  services: values.services.map((line) => ({
    service_id: line.service_id,
    staff_id: line.staff_id,
    start_time: line.start_time,
    duration_minutes: line.duration_minutes,
    price: line.price,
  })),
  products: values.products.map((line) => ({
    product_id: line.product_id,
    staff_id: line.staff_id,
    price: line.price,
  })),
  payments: values.payments.map((line) => ({
    method: line.method,
    amount: line.amount,
  })),
});

export const toWalkInSaleCreate = (
  values: WalkInSaleParsedValues
): WalkInSaleCreate => ({
  discount_percent: values.discount_percent,
  services: values.services.map((line) => ({
    service_id: line.service_id,
    staff_id: line.staff_id,
    start_time: WALK_IN_START_TIME_PLACEHOLDER,
    duration_minutes: line.duration_minutes,
    price: line.price,
  })),
  products: values.products.map((line) => ({
    product_id: line.product_id,
    staff_id: line.staff_id,
    price: line.price,
  })),
  payments: values.payments.map((line) => ({
    method: line.method,
    amount: line.amount,
  })),
});
